import { createApp } from '@backstage/frontend-defaults';
import {
  createFrontendModule,
  SignInPageBlueprint
} from '@backstage/frontend-plugin-api';


import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import appPlugin from '@backstage/plugin-app';


import {
  techDocsReportIssueAddonModule,
  techDocsExpandableNavigationAddonModule,
  techDocsLightBoxAddonModule,
  techDocsTextSizeAddonModule
} from '@backstage/plugin-techdocs-module-addons-contrib/alpha';


import { apis } from './apis';
import { googleAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';



import { CustomAppLayout, CustomAppNav, HomePageExtension } from './extensions';
import {
  customCatalogModule,
  customSearchModule,
  customScaffolderModule,
  customTechDocsModule,
  customApiDocsModule,
  customUserSettingsModule
} from './modules';


const appConfigModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => {

          return (props: any) => (
            <SignInPage
              {...props}
              auto
              provider={{
                id: 'google-auth-provider',
                title: 'Google',
                message: 'Sign In using Google',
                apiRef: googleAuthApiRef,
              }}
            />
          );
        },
      },
    }),
  ],
});




const customNavigationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    CustomAppLayout,
    CustomAppNav,
    HomePageExtension,
    ...apis,
  ],
});

const app = createApp({
  features: [
    appPlugin,
    appConfigModule,
    customNavigationModule,
    // Custom module overrides with nav icons and page customizations
    customCatalogModule,
    customSearchModule,
    customScaffolderModule,
    customTechDocsModule,
    customApiDocsModule,
    customUserSettingsModule,
    // Default plugins
    catalogPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    scaffolderPlugin,
    orgPlugin,
    searchPlugin,
    techdocsPlugin,
    techDocsReportIssueAddonModule,
    techDocsExpandableNavigationAddonModule,
    techDocsLightBoxAddonModule,
    techDocsTextSizeAddonModule,
    apiDocsPlugin,
    userSettingsPlugin,
    notificationsPlugin,
    kubernetesPlugin,
    signalsPlugin,
  ],

  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
});

export default app;
